import { Button, Grid, Menu, MenuItem, Typography, makeStyles } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import CloseIcon from '@material-ui/icons/Close';
import { useDispatch, useSelector } from 'react-redux';
import { Delete, Edit, MoreVert } from '@material-ui/icons';
import Steps from '../common/Steps';
import Modal from '../common/Modal';
import { showProgress } from '../../redux/actions/DealershipActions';
import Service from '../../apis/service';
import { ErrorToast, MultipleErrorToast, generateVideoUrl, notifySuccess } from '../utils/Utils';
import TemplateForm from './TemplateForm';
import VideoForm from './VideoForm';
import ContentFrom from './ContentFrom';
import InteractionForm from './InteractionForm';
import { ContentCard, InteractionCard, VideoCard } from './Cards';
import { apiEndpoints } from '../../constants/apiEndpoints';
const useStyles = makeStyles(() => ({
  popupContainer: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  templates: {
    height: '60vh',
    width: '97%',
    background: '#f3f4f7',
    padding: '15px 10px',
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
    overflowY: 'auto',
  },
  inputField: {
    width: '90%',
    padding: '15px 10px',
    borderRadius: '5px',
    border: '1px solid gray',
    outline: 'none',
    marginTop: '5px',
    background: 'transparent',
  },

  upload: {
    border: '1px solid gray',
    padding: '10px',
    marginTop: '5px',
    width: '90%',
    borderRadius: '5px',
  },

  required_field: {
    color: '#667085',
    '&:after': {
      content: "' *'",
      color: '#F50000',
    },
  },
  addAction: {
    display: 'flex',
    flexDirection: 'column',
    border: '1px solid gray',
    padding: '0px 10px',
  },
  videoInfo: {
    display: 'flex',
    flexDirection: 'column',
    gap: '5px',
    justifyContent: 'center',
  },
  interaction: {
    background: '#fefefe',
    marginTop: '10px',
    marginBottom: '5px',
    padding: '10px',
    display: 'flex',
    gap: '20px',
    borderRadius: '5px',
  },
  thumbnail: {
    width: '80px',
    height: '70px',
  },
  flag: {
    width: '70px',
    height: '70px',
    background: '#EBE9FE',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
  },
  content: {
    background: '#fefefe',
    marginTop: '10px',
    marginBottom: '5px',
    padding: '10px',
    display: 'flex',
    gap: '20px',
    borderRadius: '5px',
  },
  video: {
    background: '#fefefe',
    marginTop: '10px',
    marginBottom: '5px',
    padding: '10px',
    display: 'flex',
    gap: '20px',
    borderRadius: '5px',
  },
}));

export default function AddTemplatePopup({
  isAddNewTemplate,
  setIsAddNewTemplate,
  getTemplates,
  setIsEditTemplate,
  isEdit,
  dataSelected,
  interactionTypes,
  getFuels,
}) {
  const classes = useStyles();
  const dispatch = useDispatch();

  const fuelSelected = useSelector((state) => state.rockedFuelData.selectedFuel);

  const [step, setStep] = useState(1);
  const [tempName, setTempName] = useState('');
  const [tempSummary, setTempSummary] = useState('');
  const [tempOutline, setTempOutline] = useState('');
  const DEFAULT_ACTION_STATE = {
    video: false,
    content: false,
    interaction: false,
  };
  const [isOpenAction, setIsOpenAction] = useState(DEFAULT_ACTION_STATE);
  const [videosList, setVideosList] = useState([]);
  const [contentsList, setContentsList] = useState([]);
  const [interactionsList, setInteractionsList] = useState([]);
  const [thumbnailList, setThumbnailsList] = useState([]);
  const [imagdDataList, setImageDataList] = useState([]);
  const [urlValue, setUrlValue] = useState('');
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorElVid, setAnchorElVid] = useState(null);
  const [idToDelete, setIdToDelete] = useState(null);
  const [thumbIndex, setThumbIndex] = useState(null);
  const [videosImageUpdate, setVideosImageUpdate] = useState([]);
  const [videosImageUpdateId, setVideosImageUpdateId] = useState([]);
  const [editData, setEditData] = useState(null);
  const [videoThumbnail, setVideoThumbnail] = useState('');
  const [videoImageData, setVideoImageData] = useState('');
  const [isAdd, setIsAdd] = useState(null);
  const [anchorElCon, setAnchorElCon] = useState(null);

  useEffect(() => {
    if (isEdit) {
      setTempName(dataSelected?.title);
      setTempSummary(dataSelected?.summary);
      setTempOutline(dataSelected?.outline);

      const activityTypes = dataSelected?.activities || [];
      const categorizedActivities = activityTypes.reduce((accumulator, activity) => {
        const { type } = activity;
        if (!accumulator[type]) {
          accumulator[type] = [];
        }
        accumulator[type].push(activity);
        return accumulator;
      }, {});
      const videos = categorizedActivities.video?.[0] || {};
      const contents = categorizedActivities.content?.[0] || {};
      const interactions = categorizedActivities.interaction?.[0] || {};

      const tempVideos = [];
      const tempthumbs = [];
      videos?.list?.forEach((vid) => {
        const temp = {
          id: vid.id,
          title: vid.title,
          link: vid.av?.url,
          av: vid.av,
          decryptedUrl: generateVideoUrl(vid.av),
          duration: vid.duration,
          overview: vid.overview,
        };
        tempVideos.push(temp);
        tempthumbs.push(vid.thumbnail);
      });
      setVideosList([...videosList, ...tempVideos]);
      setThumbnailsList([...thumbnailList, ...tempthumbs]);

      const temp1 = {
        overview: contents?.content?.overview,
        duration: contents?.content?.duration,
      };
      if (temp1.overview) {
        setContentsList([...contentsList, temp1]);
      }

      const tempInteractions = [];

      interactions?.list?.forEach((int) => {
        const temp2 = {
          id: int.id,
          title: int.title,
          link: int.link,
          duration: int.duration,
          overview: int.overview,
          activityTypeId: int.subTypeId,
        };
        tempInteractions.push(temp2);
      });

      setInteractionsList([...interactionsList, ...tempInteractions]);
    }
  }, []);

  useEffect(() => {
    if (!isEdit) {
      setTempName('');
      setTempSummary('');
      setTempOutline('');
    }
  }, [isAddNewTemplate]);

  const handleChangeForm = (e, field, formData, setFromData) => {
    if (field === 'activityTypeId') {
      setFromData({
        ...formData,
        [field]: parseInt(e.target.value, 10),
      });
    } else {
      setFromData({
        ...formData,
        [field]: e.target.value,
      });
    }
  };

  const handleBack = () => {
    if (!isOpenAction.content && !isOpenAction.interaction && !isOpenAction.video) {
      setStep(1);
    } else {
      clearState();
    }
    setAnchorEl(null);
    setAnchorElVid(null);
  };

  const handleActionClick = (action) => {
    setIsAdd(true);
    setEditData(null);
    setIsOpenAction({
      ...isOpenAction,
      [action]: true,
    });
  };

  const handleUrlChange = (e) => {
    setUrlValue(e.target.value);
  };

  const clearState = () => {
    setIsOpenAction(DEFAULT_ACTION_STATE);
    setAnchorEl(null);
    setAnchorElVid(null);
    setAnchorElCon(null);
    setEditData(null);
    setVideoThumbnail('');
    setVideoImageData();
    setIsAdd(null);
    setUrlValue('');
  };

  const handleActionClickEdit = (event, data, type, index) => {
    setIsAdd(false);
    setIdToDelete(data?.id);
    setThumbIndex(index);
    if (type === 'video') {
      setAnchorElVid(event.currentTarget);
      setEditData(data);
      setVideoThumbnail(thumbnailList[index]);
    }
    if (type === 'content') {
      setAnchorElCon(event.currentTarget);
      setEditData(data);
    }
    if (type === 'interaction') {
      setAnchorEl(event.currentTarget);
      setEditData(data);
      setUrlValue(data.link);
    }
  };

  const handleTemplate = async () => {
    if (step === 1) {
      if (!handleValidation('template')) return;
      if (isEdit) {
        dispatch(showProgress(true));

        try {
          await Service.post(apiEndpoints.FUEL_TEMPLATE_BY_ID.replace('ID', dataSelected?.id), {
            title: tempName,
            summary: tempSummary,
            outline: tempOutline,
          });
          notifySuccess('Template updated successfully');
          setStep(2);
        } catch (error) {
          ErrorToast(error);
        }
        dispatch(showProgress(false));
      } else {
        setStep(2);
      }
    } else {
      dispatch(showProgress(true));
      if (interactionsList?.length < 1) {
        ErrorToast('Please add at least one interaction to save this template');
        dispatch(showProgress(false));
        return;
      }

      if (!isEdit) {
        const datas = new global.FormData();
        datas.append('fuelId', fuelSelected.id);
        datas.append('title', tempName);
        datas.append('summary', tempSummary);
        datas.append('outline', tempOutline);
        datas.append('interactions', JSON.stringify(interactionsList));
        if (contentsList.length > 0) {
          datas.append('content', JSON.stringify(contentsList[0]));
        }
        if (videosList.length > 0) {
          datas.append('videos', JSON.stringify(videosList));
          imagdDataList?.map((img) => datas.append('thumbnails', img));
        }

        try {
          await Service.post(apiEndpoints.FUEL_TEMPLATE_CREATE, datas);
          notifySuccess('Created fuel template successfully');
          setIsAddNewTemplate(false);
          setIsEditTemplate(false);
          getTemplates();
          getFuels();
        } catch (error) {
          ErrorToast(error);
        }
      } else {
        const data = new global.FormData();
        data.append('interactions', JSON.stringify(interactionsList));
        if (contentsList.length > 0) {
          data.append('content', JSON.stringify(contentsList[0]));
        }
        if (videosList.length > 0) {
          const tempVideos = [];
          videosList?.forEach((vid) => {
            const temp = {
              id: vid.id,
              title: vid.title,
              link: vid.av?.url === vid.link ? vid.decryptedUrl : vid.link,
              duration: vid.duration,
            };
            if (vid.overview) {
              temp.overview = vid.overview;
            }
            tempVideos.push(temp);
          });
          data.append('videos', JSON.stringify(tempVideos));

          // eslint-disable-next-line array-callback-return
          videosImageUpdate?.map((img, index) => {
            if (img) {
              data.append(`thumbnails_${videosImageUpdateId[index]}`, img);
            }
          });

          // eslint-disable-next-line array-callback-return
          imagdDataList?.map((img) => {
            if (img) {
              data.append('thumbnails', img);
            }
          });
        }

        try {
          await Service.post(apiEndpoints.FUEL_ACTIVITY_UPDATE.replace('ID', dataSelected?.id), data);
          notifySuccess('Updated fuel template successfully');
          setIsAddNewTemplate(false);
          setIsEditTemplate(false);
          getTemplates();
          getFuels();
        } catch (error) {
          ErrorToast(error);
        }
      }
    }
    dispatch(showProgress(false));
  };

  const DeleteActivity = async (type) => {
    if (type === 'Interaction') {
      if (interactionsList?.length <= 1) {
        ErrorToast('At least one interaction is required in a template');
        return;
      }
      if (!idToDelete) {
        const ints = interactionsList;
        ints.splice(thumbIndex, 1);
        setInteractionsList(ints);
        setAnchorEl(null);
        setEditData(null);
        setUrlValue('');
      } else {
        const temp = interactionsList?.filter((i) => i.id !== idToDelete);
        setInteractionsList(temp);
        setAnchorEl(null);
        setEditData(null);
        setUrlValue('');
      }
    }

    if (contentsList.length > 0) {
      if (type === 'Content') {
        setContentsList([]);
        setAnchorElCon(null);
      }
    }
    if (videosList.length > 0) {
      if (type === 'Video') {
        const temp1 = videosList?.filter((v) => v.id !== idToDelete);

        const imgDatas = imagdDataList;
        imgDatas.splice(thumbIndex - videosList.length, 1);

        const thumbnailTemps = thumbnailList;
        thumbnailTemps.splice(thumbIndex, 1);
        setThumbnailsList(thumbnailTemps);
        if (!idToDelete) {
          const videos = videosList;
          videos.splice(thumbIndex, 1);
          setVideosList(videos);
          setImageDataList(imgDatas);
          setVideoImageData('');
          setVideoThumbnail('');
          setAnchorElVid(null);
          setEditData(null);
        } else {
          setVideosList(temp1);
          setAnchorElVid(null);
          setEditData(null);
          setVideoImageData('');
          setVideoThumbnail('');
        }
      }
    }
  };

  const handleValidation = (formType) => {
    let isCorrect = true;
    const errors = [];

    switch (formType) {
      case 'template':
        if (!tempName) {
          isCorrect = false;
          errors.push('Please enter template name.');
        }
        if (!tempSummary) {
          isCorrect = false;
          errors.push('Please enter template summary.');
        }
        if (!tempOutline) {
          isCorrect = false;
          errors.push('Please enter template outline.');
        }
        break;

      default:
        break;
    }

    if (errors.length !== 0) {
      MultipleErrorToast(errors);
    }
    return isCorrect;
  };

  const getMenu = (type, anchor) => (
    <Menu
      id="simple-menu"
      keepMounted
      anchorEl={anchor}
      open={Boolean(anchor)}
      onClose={() => setAnchorElVid(null)}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
    >
      <MenuItem
        style={{ justifyContent: 'left' }}
        onClick={() =>
          setIsOpenAction({
            ...isOpenAction,
            [type.toLowerCase()]: true,
          })
        }
      >
        <Edit style={{ marginRight: '5px' }} /> Edit {type}
      </MenuItem>
      <MenuItem style={{ justifyContent: 'left' }} onClick={() => DeleteActivity(type)}>
        <Delete style={{ marginRight: '5px' }} /> Delete {type}
      </MenuItem>
    </Menu>
  );

  return (
    <Modal isOpen={isAddNewTemplate} height="85vh" width="45vw">
      <Grid className={classes.popupContainer}>
        <Grid container direction="row" justifyContent="space-between" alignItems="flex-start">
          <Grid item>
            <Grid item style={{ fontWeight: '600', fontSize: '18px' }}>
              {isEdit ? 'Edit Template' : 'Add Template'}
            </Grid>
          </Grid>
          <Grid item>
            <CloseIcon onClick={() => setIsAddNewTemplate(false)} style={{ cursor: 'pointer' }} />
          </Grid>
        </Grid>
        <Steps step={step} stepInfo={['Template Info', 'Template Content']} />
        {step === 1 ? (
          <TemplateForm
            formName={tempName}
            setFormName={setTempName}
            formSummary={tempSummary}
            setFormSummary={setTempSummary}
            formOutline={tempOutline}
            setFormOutline={setTempOutline}
          />
        ) : (
          <>
            {!isOpenAction.content && !isOpenAction.interaction && !isOpenAction.video && (
              <Grid className={classes.templates}>
                <Typography variant="p" style={{ color: '#667085' }}>
                  Note: Add at least a interaction to save this template.
                </Typography>
                <Grid className={classes.addAction} style={{}}>
                  <Grid style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Typography>Video</Typography>
                    <Button color="primary" onClick={() => handleActionClick('video')}>
                      + Add Video
                    </Button>
                  </Grid>

                  {videosList.map((videoActivity, index) => (
                    <VideoCard
                      data={videoActivity}
                      handleAction={handleActionClickEdit}
                      imageList={thumbnailList}
                      index={index}
                    />
                  ))}
                  {getMenu('Video', anchorElVid)}
                </Grid>
                <Grid className={classes.addAction}>
                  <Grid style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Typography>Content</Typography>
                    {contentsList.length === 0 ? (
                      <Button color="primary" onClick={() => handleActionClick('content')}>
                        + Add Content
                      </Button>
                    ) : (
                      <div>
                        <MoreVert
                          style={{ cursor: 'pointer' }}
                          onClick={(e) => handleActionClickEdit(e, contentsList[0], 'content')}
                        />
                      </div>
                    )}
                  </Grid>

                  {contentsList.map((contentActivity) => (
                    <ContentCard data={contentActivity} />
                  ))}
                  {getMenu('Content', anchorElCon)}
                </Grid>
                <Grid className={classes.addAction}>
                  <Grid style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Typography>Interaction</Typography>
                    <Button color="primary" onClick={() => handleActionClick('interaction')}>
                      + Add Interaction
                    </Button>
                  </Grid>
                  {interactionsList.map((interactionActivity, index) => (
                    <InteractionCard data={interactionActivity} index={index} handleAction={handleActionClickEdit} />
                  ))}
                  {getMenu('Interaction', anchorEl)}
                </Grid>
              </Grid>
            )}
            {isOpenAction.video && (
              <VideoForm
                setVideosImageUpdate={setVideosImageUpdate}
                setThumbnailsList={setThumbnailsList}
                videosList={videosList}
                imagdDataList={imagdDataList}
                setImageDataList={setImageDataList}
                videosImageUpdate={videosImageUpdate}
                videosImageUpdateId={videosImageUpdateId}
                thumbnailList={thumbnailList}
                thumbIndex={thumbIndex}
                setVideosImageUpdateId={setVideosImageUpdateId}
                videoImageData={videoImageData}
                handleChangeForm={handleChangeForm}
                videoThumbnail={videoThumbnail}
                setVideoImageData={setVideoImageData}
                setVideoThumbnail={setVideoThumbnail}
                setVideosList={setVideosList}
                handleBack={handleBack}
                clearState={clearState}
                editData={editData}
                isAdd={isAdd}
              />
            )}
            {isOpenAction.content && (
              <ContentFrom
                handleChangeForm={handleChangeForm}
                handleBack={handleBack}
                setContentsList={setContentsList}
                editData={editData}
                clearState={clearState}
              />
            )}
            {isOpenAction.interaction && (
              <InteractionForm
                interactionsList={interactionsList}
                setInteractionsList={setInteractionsList}
                handleChangeForm={handleChangeForm}
                interactionTypes={interactionTypes}
                setUrlValue={setUrlValue}
                urlValue={urlValue}
                handleUrlChange={handleUrlChange}
                handleBack={handleBack}
                clearState={clearState}
                editData={editData}
                isAdd={isAdd}
                thumbIndex={thumbIndex}
              />
            )}
          </>
        )}
        {!isOpenAction.interaction && !isOpenAction.content && !isOpenAction.video && (
          <Grid style={{ display: 'flex' }}>
            {step === 2 && (
              <Button onClick={handleBack} variant="outlined">
                Back
              </Button>
            )}
            <Grid container direction="row" justifyContent="flex-end" alignItems="center">
              <>
                <Button onClick={() => setIsAddNewTemplate(false)} variant="outlined">
                  Cancel
                </Button>
                <Button variant="contained" color="primary" style={{ marginLeft: '10px' }} onClick={handleTemplate}>
                  {step === 1 ? 'Next' : 'Save'}
                </Button>
              </>
            </Grid>
          </Grid>
        )}
      </Grid>
    </Modal>
  );
}
